import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["newTaskForm", "icon", "taskInput"]

  refocusInput() {
    // Refocus the input if the form is visible
    if (!this.newTaskFormTarget.classList.contains("hidden") && this.hasTaskInputTarget) {
      // Use requestAnimationFrame to ensure DOM has fully updated
      requestAnimationFrame(() => {
        this.taskInputTarget.focus()
      })
    }
  }

  toggleForm() {
    const isHidden = this.newTaskFormTarget.classList.toggle("hidden")

    // Rotate + to 45deg to make it look like ×
    if (isHidden) {
      this.iconTarget.style.transform = "rotate(0deg)"
    } else {
      this.iconTarget.style.transform = "rotate(45deg)"
    }

    // Focus on input when form is shown
    if (!isHidden && this.hasTaskInputTarget) {
      this.taskInputTarget.focus()
    }
  }
}
